import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "Bullhorn"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M19.5002 4.5V6.1275L4.2302 8.9025C3.50856 9.03445 2.98824 9.66899 3.0002 10.4025V13.6575C2.98824 14.391 3.50856 15.0255 4.2302 15.1575L6.0002 15.42V18C6.0002 18.8284 6.67177 19.5 7.5002 19.5H13.5002C14.3286 19.5 15.0002 18.8284 15.0002 18V17.055L19.5002 17.8725V19.5H21.0002V4.5H19.5002ZM13.5003 18H7.50027V15.6975L13.5003 16.785V18ZM4.50027 13.6275V10.3725L19.5003 7.65001V16.35L4.50027 13.6275Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/Bullhorn.vue"]]);
